import "./App.scss";
import Game from "./components/game";

function App() {
  return (
    <div className="app">
      <Game/>
    </div>
  );
}

export default App;
